// src/components/admin/AdminLogin.jsx
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) {
      setError('Pogrešan email ili lozinka.');
    } else {
      navigate('/admin');
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #e8ebeeff 0%, #e9ecef 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: '#fff', borderRadius: '12px', padding: '2.5rem', width: '100%', maxWidth: '400px', boxShadow: '0 8px 32px rgba(66,89,168,0.12)' }}>
        <h1 style={{ color: '#4259A8', fontSize: '1.5rem', fontWeight: 700, marginBottom: '0.25rem' }}>Admin</h1>
        <p style={{ color: '#6c757d', fontSize: '0.9rem', marginBottom: '2rem' }}>Poliklinika Akrion</p>

        {error && (
          <div style={{ background: 'rgba(220,53,69,0.1)', border: '1px solid rgba(220,53,69,0.3)', color: '#721c24', borderRadius: '8px', padding: '0.75rem 1rem', marginBottom: '1.25rem', fontSize: '0.9rem' }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '1rem' }}>
            <label style={labelStyle}>Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required style={inputStyle} placeholder="admin@poliklinika-akrion.hr" />
          </div>
          <div style={{ marginBottom: '1.5rem' }}>
            <label style={labelStyle}>Lozinka</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required style={inputStyle} placeholder="••••••••" />
          </div>
          <button type="submit" disabled={loading} style={btnStyle}>
            {loading ? 'Prijava…' : 'Prijava'}
          </button>
        </form>
      </div>
    </div>
  );
}

const labelStyle = { display: 'block', fontSize: '0.85rem', fontWeight: 600, color: '#495057', marginBottom: '0.4rem' };
const inputStyle = { width: '100%', padding: '10px 14px', border: '2px solid rgba(66,89,168,0.15)', borderRadius: '8px', fontSize: '0.95rem', color: '#495057', outline: 'none', boxSizing: 'border-box' };
const btnStyle = { width: '100%', padding: '12px', background: 'linear-gradient(135deg, #4259A8 0%, #2E8DD7 100%)', border: 'none', borderRadius: '8px', color: '#fff', fontWeight: 700, fontSize: '1rem', cursor: 'pointer' };